import React from 'react';

/**
 * LoadingSpinner - Reusable loading indicator component
 * 
 * @param {Object} props - Component props
 * @param {string} [props.size='medium'] - Size of the spinner (small, medium, large)
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {Object} [props.style={}] - Additional inline styles
 * @returns {React.ReactElement} Loading spinner component
 */
const LoadingSpinner = ({ size = 'medium', className = '', style = {} }) => {
  // Size configurations
  const sizeConfig = {
    small: { width: '12px', height: '12px', borderWidth: '2px' },
    medium: { width: '20px', height: '20px', borderWidth: '2px' },
    large: { width: '40px', height: '40px', borderWidth: '3px' }
  };

  const spinnerSize = sizeConfig[size] || sizeConfig.medium;

  return (
    <div 
      className={`loader ${className}`}
      style={{
        ...spinnerSize,
        ...style
      }}
    ></div>
  );
};

export default LoadingSpinner;